import { Popup } from 'devextreme-react/popup'
import { Button } from 'devextreme-react/ui/button'
import React, { FC, useState } from 'react'
import appLogo from '../../../../public/icon_72.png'
import './update-pop-up.scss'

type Props = {
    visible: boolean,
    onUpdate: () => void,
}

export const UpdatePopUp: FC<Props> = ({ visible, onUpdate}) => {

    const [isUpdating, setIsUpdating] = useState<boolean>(false)
    
    const handleUpdate = () => {
        setIsUpdating(true)
        onUpdate()
    }

    return (
        <Popup
            visible={visible}
            width={'100vw'}
            height={'100vh'}
            showCloseButton={false}
            title={'Update Available'}
            closeOnOutsideClick={false}
            showTitle={false}
        >
            <div className={'update-pop-up-container'}>
                <img src={appLogo} height='72px' width='auto' ></img>
                <div className={'update-pop-up-heading'}>Update Available</div>
                <div className={'update-pop-up-content'}>A new update is ready to be installed. This must be done to continue using the application.</div>
                <div className={'update-pop-up-button'}>
                    {isUpdating ?
                        <div>Updating...</div>
                    :
                        <Button
                            text='Update'
                            icon='refresh'
                            type='default'
                            stylingMode='contained'
                            onClick={handleUpdate}
                        />
                    }
                </div>
            </div>
        </Popup>
    )
}